import { Link } from "react-router-dom";
import { SERVICE_OPTIONS } from "@/lib/api";
import { ArrowRight, Wrench, Trophy, Cog, Circle, SprayCan } from "lucide-react";

const iconMap = {
  engine_rebuild: Wrench,
  custom_bike_build: Trophy,
  aftermarket_parts_fitting: Cog,
  bearing_replacement: Circle,
  new_bike_prep: SprayCan,
};

export default function Services() {
  return (
    <div data-testid="services-page" className="max-w-7xl mx-auto px-4 sm:px-8 py-16 sm:py-24">
      <div className="mb-16 max-w-3xl">
        <span className="font-mono text-xs uppercase tracking-widest text-orange-500">— Our Services</span>
        <h1 className="font-display text-5xl sm:text-7xl uppercase mt-2 mb-4">Precision. Not Guesswork.</h1>
        <p className="text-zinc-300 text-lg">
          From a full engine rebuild to pressing in a set of head race bearings — every job leaves
          the shop torqued, greased, and race-ready.
        </p>
      </div>

      <div className="grid gap-px bg-white/10 border border-white/10">
        {SERVICE_OPTIONS.map((s, i) => {
          const Icon = iconMap[s.value];
          return (
            <div
              key={s.value}
              data-testid={`service-card-${s.value}`}
              className="bg-zinc-950 p-8 md:p-12 grid md:grid-cols-12 gap-6 items-center hover:bg-zinc-900/60 transition-colors group"
            >
              <div className="md:col-span-1">
                <span className="font-mono text-xs text-orange-500">0{i + 1}</span>
              </div>
              <div className="md:col-span-1">
                <Icon size={36} className="text-orange-500" />
              </div>
              <div className="md:col-span-7">
                <h2 className="font-display text-3xl sm:text-4xl uppercase mb-2">{s.label}</h2>
                <p className="text-zinc-400">{s.desc}</p>
              </div>
              <div className="md:col-span-3 md:text-right">
                <Link
                  to="/book"
                  state={{ service: s.value }}
                  className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-widest text-white border-b border-orange-500 pb-1 group-hover:text-orange-400"
                >
                  Book This <ArrowRight size={14} />
                </Link>
              </div>
            </div>
          );
        })}
      </div>

      <div className="mt-16 border border-orange-600/40 bg-orange-600/5 p-8 md:p-12 grid md:grid-cols-12 gap-6 items-center">
        <div className="md:col-span-8">
          <h3 className="font-display text-3xl sm:text-4xl uppercase mb-2">Not sure which service you need?</h3>
          <p className="text-zinc-300">Start a booking — tell us what you've got, we'll come back with the plan.</p>
        </div>
        <div className="md:col-span-4 md:text-right">
          <Link to="/book" className="btn-hard inline-flex items-center gap-2 bg-orange-600 text-white px-8 py-4 font-display uppercase tracking-widest text-sm">
            Book Now <ArrowRight size={16} />
          </Link>
        </div>
      </div>
    </div>
  );
}
